import { apiCall } from '../../context/api';

export const disconnectSystem = async (base_url, token, company, setCompany, system) => {
  await apiCall(base_url, token, 'POST', `/core/users/disconnect/${system}`, null, {
    useBearerAuth: false
  });

  if (system === 'crm') {
    setCompany({ ...company, crm_connected: null, crm_id: null, crm_refresh: null });
  } else if (system === 'acct') {
    setCompany({ ...company, acct_connected: null, acct_id: null, acct_refresh: null });
  } else if (system === 'acct-secondary') {
    setCompany({ ...company, sec_acct_connected: null, sec_acct_id: null, sec_acct_refresh: null });
  }
};
